define(
    "diy/undo-redo/executor/Main",
    [
        'diy/undo-redo/executor/Base',
        'diy/undo-redo/constants'
    ],
    /**
     *
     * @param {module.undoRedo.Executor.Base} Base
     * @param {module.undoRedo.constants} constants
     * @returns {*}
     */
    function (Base, constants) {
        'use strict';
        var MainExecutor;

        /**
         * @class module.undoRedo.Executor.Main
         * @template module.undoRedo.Executor.Main
         * @lends {module.undoRedo.Executor.Main.prototype}
         * @extends {module.undoRedo.Executor.Base}
         * @constructor
         */
        MainExecutor = Base.extend({

            type: constants.executionType.SERVER,

            /** @type {module.undoRedo.Executor.Factory} */
            factory: null,
            /**
             *
             * @param {module.undoRedo.Executor.Factory} factory
             */
            setFactory: function setFactory(factory) {
                this.factory = factory;
            },
            /**
             * Formats a linear chain on entries to the following structure based on execution type
             *  position as in original chain is kept
             *
             *  [
             *      {type: 'server', items: [items...]},
             *      {type: 'client', items: [items...]},
             *      {type: 'server': items: [items...]}
             *  ]
             *
             * @param {module.undoRedo.Entry[]} chain
             * @returns {Array.<{type: String, items: module.undoRedo.Entry[]}>}
             */
            splitOnExecutorType: function splitOnExecutorType(chain) {
                return chain.reduce(function (previous, current) { //, index, array) {
                    var
                        lastElement = previous[previous.length - 1],

                        newSection = function (previous, current) {
                            var object = {};
                            object.type = current.getExecutionType();
                            object.items = [current];
                            previous.push(object);
                        };

                    if (!lastElement) {
                        newSection(previous, current);
                    } else {
                        if (lastElement.type === current.getExecutionType()) {
                            lastElement.items.push(current);
                            previous[previous.length - 1] = lastElement;
                        } else {
                            newSection(previous, current);
                        }
                    }


                    return previous;
                }, []);
            },
            /**
             *
             * @param {module.undoRedo.Entry} entry
             * @returns {Promise|Q.promise}
             */
            execute: function execute(entry) {
                var
                    deferred = Q.defer(),
                    execution = [],
                    result = [],
                    identitySets,
                    entryChain,
                    sessionHeadEntry;

                try {
                    entryChain = entry.getChain(this.history.chains);

                    if (entry.getExecutionType() === constants.executionType.CLIENT) {
                        if (entry.getType() === constants.types.UNDO && entry.getSessionIndex() === 1) {
                            sessionHeadEntry = this.history.getEntryByKey(entry.getLinkedEntryId().toString());
                            entry = (sessionHeadEntry === null) ? entry : sessionHeadEntry;
                        }
                    }

                    identitySets = this.splitOnExecutorType(entryChain.slice(0, entry.getPositionInChain(entryChain) + 1));

                    identitySets.forEach(function (identitySet, index) {
                        execution.push(this.executeSet.bind(this, identitySet, result, (index === identitySets.length - 1)));
                    }.bind(this));

                    execution.reduce(Q.when, Q(result))
                        .then(function executionEnded() {
                            this.applyExecution(result)
                                .done(
                                    function onFulfilled() {
                                        this.api.notifyObservers(constants.observerTopics.EXECUTION_FINISHED, result);
                                        deferred.resolve(true);
                                    }.bind(this),
                                    function onRejected(error) {
                                        deferred.reject(error);
                                    }
                                );
                        }.bind(this))
                        .catch(function (error) {
                            deferred.reject(error);
                        });
                } catch (error) {
                    deferred.reject(error);
                }
                return deferred.promise;
            },
            /**
             *
             * @param {Array.<module.undoRedo.ExecutedEntry>} items
             */
            applyExecution: function applyExecution(items) {
                var toApply = [];
                items.forEach(function (item) {
                    toApply.push(function seqApply() {
                        return Q(item.callOnExecutedLast());
                    });
                });

                return toApply.reduce(Q.when, Q(true));
            },
            /**
             *
             * @param {{type: String, items: module.undoRedo.Entry[]}} identitySet
             * @param {Array.<module.undoRedo.ExecutedEntry>} result
             * @param {Boolean} hasLastEntry
             * @returns {*}
             */
            executeSet: function executeSet(identitySet, result, hasLastEntry) {
                var executor;
                executor = this.factory.build(identitySet.type);

                return executor.executeSet(identitySet.items, result, hasLastEntry);
            }
        });

        return MainExecutor;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/executor/Main.js
 ** module id = 913
 ** module chunks = 0
 **/